(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6682"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6682"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8hRDK", function(module, exports) {

$parcel$export(module.exports, "RUNTIME_BYTES", () => $60898514af44a1e9$export$b5bf5d5b2906164d);
$parcel$export(module.exports, "explainLoadError", () => $60898514af44a1e9$export$53fc5a413a89d8a9);
$parcel$export(module.exports, "loadRuntime", () => $60898514af44a1e9$export$35ec577535b9239b);
$parcel$export(module.exports, "sessionFor", () => $60898514af44a1e9$export$e7ac982469b12cda);
// Getting a model into the browser and ready to run.
//
// Two tools need this now, so it sits here rather than inside either of them:
// the runtime is loaded once per page whatever asks for it, and the download of
// a model is the slowest thing on the page and is worth caching exactly once.
//
// The files come from this origin, put there by scripts/build-tools-assets.js.
// Nothing here reaches anywhere else, which is what lets the pages promise that
// a picture never leaves the machine.
const $60898514af44a1e9$var$RUNTIME_URL = '/plugins/onnxruntime/ort.wasm.min.js';
const $60898514af44a1e9$var$RUNTIME_PATH = '/plugins/onnxruntime/';
const $60898514af44a1e9$var$MODEL_CACHE = 'imageserver-tools-models-v1';
const $60898514af44a1e9$export$b5bf5d5b2906164d = 12739637;
function $60898514af44a1e9$export$53fc5a413a89d8a9(err) {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) return "You are offline, and this tool has not been downloaded to this browser yet. Connect once and try again; after that it works without a connection.";
    const message = err && err.message ? err.message : '';
    if (/runtime|model|fetch|network|load/i.test(message)) return 'The tool could not be downloaded. Check your connection and try again.';
    return message || 'Something went wrong. Try again.';
}
let $60898514af44a1e9$var$runtimePromise = null;
const $60898514af44a1e9$var$sessions = new Map();
function $60898514af44a1e9$export$35ec577535b9239b() {
    if ($60898514af44a1e9$var$runtimePromise) return $60898514af44a1e9$var$runtimePromise;
    $60898514af44a1e9$var$runtimePromise = new Promise((resolve, reject)=>{
        const script = document.createElement('script');
        script.src = $60898514af44a1e9$var$RUNTIME_URL;
        script.onload = ()=>{
            if (!window.ort) {
                reject(new Error('The image runtime loaded but did not start'));
                return;
            }
            // Without this the runtime looks for its wasm next to the page.
            window.ort.env.wasm.wasmPaths = $60898514af44a1e9$var$RUNTIME_PATH;
            // The page is not cross-origin isolated, so SharedArrayBuffer is
            // unavailable and threads cannot work. Saying so up front skips a
            // failed worker start and a console error on every run.
            window.ort.env.wasm.numThreads = 1;
            resolve(window.ort);
        };
        script.onerror = ()=>{
            // Gone again, so the next attempt adds a fresh tag instead of
            // waiting on one that has already failed.
            script.remove();
            reject(new Error('Could not load the image runtime'));
        };
        document.head.appendChild(script);
    });
    // A failed load is not kept: without this, every later attempt on the page
    // would get the same rejection and "Try again" could never work.
    $60898514af44a1e9$var$runtimePromise.catch(()=>{
        $60898514af44a1e9$var$runtimePromise = null;
    });
    return $60898514af44a1e9$var$runtimePromise;
}
/**
 * The model bytes, from the Cache Storage if they are already there.
 *
 * Read with a stream rather than as one blob so a large model can report how
 * far along it is. Cache Storage needs a secure context, so a plain http origin
 * quietly falls back to downloading each time.
 */ async function $60898514af44a1e9$var$fetchModel(model, onProgress) {
    let cache = null;
    try {
        cache = await caches.open($60898514af44a1e9$var$MODEL_CACHE);
        const hit = await cache.match(model.file);
        if (hit) return await hit.arrayBuffer();
    } catch (err) {
    // No Cache Storage here. Not worth telling anyone about; it costs a
    // download on the next visit and nothing else.
    }
    const response = await fetch(model.file);
    if (!response.ok) throw new Error(`Could not load the ${model.label.toLowerCase()} model`);
    const total = Number(response.headers.get('content-length')) || model.bytes;
    const reader = response.body?.getReader();
    if (!reader) return await response.arrayBuffer();
    const chunks = [];
    let received = 0;
    for(;;){
        const { done: done, value: value } = await reader.read();
        if (done) break;
        chunks.push(value);
        received += value.length;
        if (onProgress) onProgress(Math.min(1, received / total));
    }
    const bytes = new Uint8Array(received);
    let offset = 0;
    for (const chunk of chunks){
        bytes.set(chunk, offset);
        offset += chunk.length;
    }
    // Cached from the bytes rather than from a clone of the response. Handing
    // the cache a clone makes it consume the whole body before this reader sees
    // a chunk, which leaves the progress bar at nothing for the entire download
    // and then finishes it in one jump.
    if (cache) try {
        await cache.put(model.file, new Response(bytes));
    } catch (err) {
    // A full quota, or a browser that will not store something this
    // large. It costs a download on the next visit and nothing else.
    }
    return bytes.buffer;
}
function $60898514af44a1e9$export$e7ac982469b12cda(model, onProgress) {
    if ($60898514af44a1e9$var$sessions.has(model.id)) return $60898514af44a1e9$var$sessions.get(model.id);
    const promise = (async ()=>{
        const ort = await $60898514af44a1e9$export$35ec577535b9239b();
        const bytes = await $60898514af44a1e9$var$fetchModel(model, onProgress);
        return ort.InferenceSession.create(bytes, {
            executionProviders: [
                'wasm'
            ],
            graphOptimizationLevel: 'all'
        });
    })();
    // Stored before it resolves so two images picked in quick succession share
    // one download, and dropped again on failure so a retry is not stuck with
    // a rejected promise.
    $60898514af44a1e9$var$sessions.set(model.id, promise);
    promise.catch(()=>$60898514af44a1e9$var$sessions.delete(model.id));
    return promise;
}

});

parcelRegister("7JAKl", function(module, exports) {

$parcel$export(module.exports, "OUTPUT_FORMATS", () => $5a193d7426028a6c$export$314b93693e42ef22);
$parcel$export(module.exports, "canEncode", () => $5a193d7426028a6c$export$32d8af07dd2de268);
$parcel$export(module.exports, "decode", () => $5a193d7426028a6c$export$2f872c0f2117be69);
$parcel$export(module.exports, "hasAlpha", () => $5a193d7426028a6c$export$7c6623716c246f1);
$parcel$export(module.exports, "sizeOf", () => $5a193d7426028a6c$export$30043de3fae42dd1);
$parcel$export(module.exports, "fitWithin", () => $5a193d7426028a6c$export$2cf9958cd81e83ad);
$parcel$export(module.exports, "draw", () => $5a193d7426028a6c$export$e529deb2bfd496dc);
$parcel$export(module.exports, "encode", () => $5a193d7426028a6c$export$c564cdbbe6da493);
$parcel$export(module.exports, "renameExtension", () => $5a193d7426028a6c$export$a7b7f54182084c78);
$parcel$export(module.exports, "saveBlob", () => $5a193d7426028a6c$export$9016c9576545678);
$parcel$export(module.exports, "formatBytes", () => $5a193d7426028a6c$export$e1a3971de07c83b5);
// Decoding, encoding and the small conveniences that both browser tools need.
//
// Everything here works on the bytes the visitor picked and never touches the
// network. That is the whole promise of /tools, so nothing in this file may
// grow a fetch of the image itself.
// Feature-detected once per page rather than per file. A browser that cannot
// encode a format answers toBlob with a PNG instead of failing, so asking for
// AVIF and trusting the result would silently hand out a mislabelled file.
const $5a193d7426028a6c$var$encoderSupport = new Map();
const $5a193d7426028a6c$export$314b93693e42ef22 = [
    {
        mime: 'image/png',
        label: 'PNG',
        extension: 'png',
        lossy: false,
        note: 'Lossless, keeps transparency'
    },
    {
        mime: 'image/jpeg',
        label: 'JPEG',
        extension: 'jpg',
        lossy: true,
        note: 'Small, no transparency'
    },
    {
        mime: 'image/webp',
        label: 'WebP',
        extension: 'webp',
        lossy: true,
        note: 'Small and keeps transparency'
    },
    {
        mime: 'image/avif',
        label: 'AVIF',
        extension: 'avif',
        lossy: true,
        note: 'Smallest, not encodable everywhere'
    }
];
function $5a193d7426028a6c$export$32d8af07dd2de268(mime) {
    if (mime === 'image/png') return Promise.resolve(true);
    if (!$5a193d7426028a6c$var$encoderSupport.has(mime)) $5a193d7426028a6c$var$encoderSupport.set(mime, new Promise((resolve)=>{
        const probe = document.createElement('canvas');
        probe.width = 1;
        probe.height = 1;
        try {
            probe.toBlob((blob)=>resolve(!!blob && blob.type === mime), mime, 0.9);
        } catch (err) {
            resolve(false);
        }
    }));
    return $5a193d7426028a6c$var$encoderSupport.get(mime);
}
async function $5a193d7426028a6c$export$2f872c0f2117be69(file) {
    if (typeof createImageBitmap === 'function') try {
        return await createImageBitmap(file, {
            imageOrientation: 'from-image'
        });
    } catch (err) {
    // Falls through. Either the format is one this browser cannot
    // decode, which the fallback will report the same way, or the
    // options argument is unsupported, which the fallback handles.
    }
    const url = URL.createObjectURL(file);
    try {
        return await new Promise((resolve, reject)=>{
            const img = new Image();
            img.onload = ()=>resolve(img);
            img.onerror = ()=>reject(new Error('This browser cannot decode that image'));
            img.src = url;
        });
    } finally{
        // Revoking immediately is safe: a loaded <img> keeps its own decoded
        // copy, and a failed one has nothing left to read.
        URL.revokeObjectURL(url);
    }
}
function $5a193d7426028a6c$export$7c6623716c246f1(image) {
    const PROBE = 128;
    const { width: width, height: height } = $5a193d7426028a6c$export$30043de3fae42dd1(image);
    const w = Math.max(1, Math.min(PROBE, width));
    const h = Math.max(1, Math.min(PROBE, height));
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d', {
        willReadFrequently: true
    });
    ctx.drawImage(image, 0, 0, w, h);
    const { data: data } = ctx.getImageData(0, 0, w, h);
    for(let i = 3; i < data.length; i += 4){
        if (data[i] < 255) return true;
    }
    return false;
}
function $5a193d7426028a6c$export$30043de3fae42dd1(image) {
    return {
        width: image.width || image.naturalWidth,
        height: image.height || image.naturalHeight
    };
}
function $5a193d7426028a6c$export$2cf9958cd81e83ad(width, height, maxWidth, maxHeight) {
    const scale = Math.min(maxWidth ? maxWidth / width : 1, maxHeight ? maxHeight / height : 1, 1);
    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale))
    };
}
function $5a193d7426028a6c$export$e529deb2bfd496dc(image, width, height, background) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    if (background) {
        ctx.fillStyle = background;
        ctx.fillRect(0, 0, width, height);
    }
    ctx.drawImage(image, 0, 0, width, height);
    return canvas;
}
function $5a193d7426028a6c$export$c564cdbbe6da493(canvas, mime, quality) {
    return new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>blob ? resolve(blob) : reject(new Error(`Could not encode as ${mime}`)), mime, // Undefined rather than a number for PNG: passing a quality to a
        // lossless encoder is meaningless, and some browsers take it as a
        // hint to switch to a lossy one.
        quality);
    });
}
function $5a193d7426028a6c$export$a7b7f54182084c78(filename, extension) {
    const stem = filename.replace(/\.[^.]+$/, '') || 'image';
    return `${stem}.${extension}`;
}
function $5a193d7426028a6c$export$9016c9576545678(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    // A revoke on the next tick rather than straight away. Chrome starts the
    // download asynchronously and reads the URL after the click returns.
    setTimeout(()=>URL.revokeObjectURL(url), 1000);
}
function $5a193d7426028a6c$export$e1a3971de07c83b5(bytes) {
    if (!bytes) return '0 B';
    const units = [
        'B',
        'KB',
        'MB',
        'GB'
    ];
    const power = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const value = bytes / Math.pow(1024, power);
    return `${value >= 100 || power === 0 ? Math.round(value) : value.toFixed(1)} ${units[power]}`;
}

});

parcelRegister("65gAn", function(module, exports) {

$parcel$export(module.exports, "wirePicker", () => $46e0134a81c5c949$export$a7ad1357dc53be0f);
$parcel$export(module.exports, "blockStrayDrops", () => $46e0134a81c5c949$export$9587a56f399e19d6);
$parcel$export(module.exports, "initColourPicker", () => $46e0134a81c5c949$export$54c51a5e259d1ae);
// The input controls both tools share: a drop zone that also takes a click or a
// paste, and the colour swatch picker beside it.
//
// Dropzone.js is already on the page from the header, but it exists to POST
// files somewhere. These tools must not send anything, so they take the files
// straight out of the event instead.
/**
 * Wire a drop zone.
 *
 * @param {object}   options
 * @param {Element}  options.zone      Element that accepts drops and clicks.
 * @param {Element}  options.input     The <input type="file"> behind it.
 * @param {boolean}  options.multiple  Whether more than one file is useful.
 * @param {Function} options.onFiles   Called with an array of image Files.
 * @returns {Function} Removes the paste listener, which is the only one that
 *                     outlives the elements.
 */ function $46e0134a81c5c949$export$a7ad1357dc53be0f({ zone: zone, input: input, multiple: multiple = false, onFiles: onFiles }) {
    const imagesOnly = (files)=>Array.from(files).filter((file)=>file.type.startsWith('image/'));
    // Whatever is left out is said, in a toast: the drop zone is often hidden
    // by then, and a file that silently does nothing reads as a broken tool.
    const tell = (message)=>{
        if (window.ui && typeof window.ui.toast === 'function') window.ui.toast(message, 'warning');
    };
    const hand = (files)=>{
        const all = Array.from(files);
        const images = imagesOnly(all);
        const skipped = all.length - images.length;
        if (skipped) tell(skipped === 1 && all.length === 1 ? `${all[0].name} is not an image, so there is nothing to do with it here.` : `${skipped} of ${all.length} files are not images and were left out.`);
        if (!images.length) return;
        if (!multiple && images.length > 1) tell(`This tool works on one image at a time, so only ${images[0].name} was opened.`);
        onFiles(multiple ? images : [
            images[0]
        ]);
    };
    zone.addEventListener('click', (event)=>{
        // input.click() dispatches a click that bubbles back here if the input
        // sits inside the zone, and opening the picker from its own click event
        // never stops.
        if (event.target === input) return;
        input.click();
    });
    zone.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            input.click();
        }
    });
    input.addEventListener('change', ()=>{
        hand(input.files);
        // Cleared so that picking the same file twice in a row still fires a
        // change event, which is what someone does after tweaking a setting.
        input.value = '';
    });
    // dragenter and dragleave fire for every child element the pointer crosses,
    // so a counter decides when the pointer has really left rather than the
    // events alone.
    let depth = 0;
    const setDragging = (on)=>zone.classList.toggle('is-dragging', on);
    zone.addEventListener('dragenter', (event)=>{
        event.preventDefault();
        depth += 1;
        setDragging(true);
    });
    zone.addEventListener('dragover', (event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
    });
    zone.addEventListener('dragleave', ()=>{
        depth = Math.max(0, depth - 1);
        if (depth === 0) setDragging(false);
    });
    zone.addEventListener('drop', (event)=>{
        event.preventDefault();
        depth = 0;
        setDragging(false);
        hand(event.dataTransfer.files);
    });
    // A screenshot on the clipboard is the shortest path into either tool, so
    // the whole document listens rather than only the focused zone.
    const onPaste = (event)=>{
        const files = Array.from(event.clipboardData?.files || []);
        if (files.length) {
            event.preventDefault();
            hand(files);
        }
    };
    document.addEventListener('paste', onPaste);
    return ()=>document.removeEventListener('paste', onPaste);
}
function $46e0134a81c5c949$export$9587a56f399e19d6() {
    for (const type of [
        'dragover',
        'drop'
    ])window.addEventListener(type, (event)=>{
        const target = event.target;
        if (target instanceof Element && target.closest('[data-picker-zone]')) return;
        event.preventDefault();
    });
}
function $46e0134a81c5c949$export$54c51a5e259d1ae() {
    if (typeof window.Coloris === 'undefined') return;
    window.Coloris({
        el: '[data-coloris]',
        theme: 'pill',
        themeMode: 'auto',
        alpha: false,
        swatches: [
            '#ffffff',
            '#e2e8f0',
            '#94a3b8',
            '#334155',
            '#0f172a',
            '#ef4444',
            '#f97316',
            '#f59e0b',
            '#22c55e',
            '#14b8a6',
            '#0ea5e9',
            '#3b82f6',
            '#6366f1',
            '#8b5cf6',
            '#ec4899'
        ]
    });
}

});

parcelRegister("1Euqv", function(module, exports) {

$parcel$export(module.exports, "wireAccountSave", () => $134120eb769dffbc$export$ef5aa585a850b1f);
// The one thing on these pages that leaves the machine.
//
// Everything else here is a promise that nothing is sent anywhere. This is the
// deliberate exception: a signed-in visitor presses a button and the finished
// picture is uploaded to their own account, encrypted like any other upload,
// through /upload/web rather than through anything new. That route already
// knows about plan limits, quotas, folders and the account's upload rules, and
// reusing it means a picture saved from a tool is not a second kind of upload
// with a second set of behaviours to keep in step.
//
// Because it is the exception, the button says what it does, it is never the
// default action, and nothing here runs unless it is pressed.
const $134120eb769dffbc$var$UPLOAD_URL = '/upload/web';
function $134120eb769dffbc$export$e3fbe444a169a808() {
    const node = document.getElementById('toolAccount');
    if (!node || node.dataset.loggedIn !== '1' || !node.dataset.csrf) return null;
    return {
        token: node.dataset.csrf
    };
}
/**
 * Upload one blob and answer with the link.
 *
 * The route replies with JSON on success and, depending on which check refused,
 * either JSON or a bare string on failure, so both shapes are handled rather
 * than assuming the happy one.
 */ async function $134120eb769dffbc$var$upload(blob, filename, token) {
    const form = new FormData();
    form.append('file', blob, filename);
    const response = await fetch($134120eb769dffbc$var$UPLOAD_URL, {
        method: 'POST',
        headers: {
            'X-CSRF-TOKEN': token
        },
        // Same-origin only, and the cookie is what identifies the account.
        credentials: 'same-origin',
        body: form
    });
    const raw = await response.text();
    let parsed = null;
    try {
        parsed = JSON.parse(raw);
    } catch (err) {
    // A plain-text error, which some of the checks in that route still send.
    }
    if (!response.ok) throw new Error(parsed && parsed.error || raw || `Upload failed (${response.status})`);
    if (!parsed || !parsed.url) throw new Error('The upload finished but did not come back with a link');
    return parsed.url;
}
/** One saved link, with a button that copies it. */ function $134120eb769dffbc$var$linkRow(name, url) {
    const row = document.createElement('li');
    row.className = 'flex items-center gap-3 p-3';
    row.innerHTML = `
        <i class="fa-solid fa-circle-check text-emerald-500 shrink-0"></i>
        <div class="min-w-0 flex-1">
            <p data-name class="truncate text-xs font-semibold text-slate-900 dark:text-white"></p>
            <a data-link target="_blank" rel="noopener"
               class="block truncate text-xs text-blue-600 hover:underline dark:text-blue-400"></a>
        </div>
        <button type="button" data-copy
            class="shrink-0 inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium bg-slate-100 dark:bg-gray-700 border border-slate-200 dark:border-gray-600 text-slate-700 dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-gray-600 transition-colors">
            <i class="fa-regular fa-copy"></i>
            <span>Copy</span>
        </button>`;
    row.querySelector('[data-name]').textContent = name;
    const link = row.querySelector('[data-link]');
    link.href = url;
    link.textContent = url;
    const copy = row.querySelector('[data-copy]');
    copy.addEventListener('click', async ()=>{
        try {
            await navigator.clipboard.writeText(url);
            copy.querySelector('span').textContent = 'Copied';
            setTimeout(()=>{
                copy.querySelector('span').textContent = 'Copy';
            }, 1500);
        } catch (err) {
            // Clipboard access can be refused. The link is on screen and
            // selectable either way, so this is not worth an alert.
            copy.querySelector('span').textContent = 'Press Ctrl+C';
        }
    });
    return row;
}
function $134120eb769dffbc$export$ef5aa585a850b1f({ button: button, panel: panel, list: list, error: error, collect: collect }) {
    if (!button) return false;
    const context = $134120eb769dffbc$export$e3fbe444a169a808();
    if (!context) {
        // No account, so the button would only ever produce a login redirect.
        button.hidden = true;
        return false;
    }
    button.hidden = false;
    button.addEventListener('click', async ()=>{
        const original = button.innerHTML;
        button.disabled = true;
        if (error) error.hidden = true;
        let items = [];
        try {
            items = (await collect()).filter((item)=>item && item.blob);
        } catch (err) {
            if (error) {
                error.hidden = false;
                error.textContent = err.message || 'Could not prepare the image';
            }
            button.disabled = false;
            return;
        }
        if (!items.length) {
            button.disabled = false;
            return;
        }
        // Uploaded one at a time rather than all at once: each one is a full
        // request through the encryption and storage path, and a browser that
        // opens ten of those in parallel gets rate limited by our own route.
        let saved = 0;
        try {
            for (const item of items){
                button.innerHTML = items.length > 1 ? `<i class="fa-solid fa-circle-notch fa-spin"></i> Saving ${saved + 1} of ${items.length}` : '<i class="fa-solid fa-circle-notch fa-spin"></i> Saving';
                const url = await $134120eb769dffbc$var$upload(item.blob, item.name, context.token);
                list.prepend($134120eb769dffbc$var$linkRow(item.name, url));
                panel.hidden = false;
                saved += 1;
            }
        } catch (err) {
            if (error) {
                error.hidden = false;
                error.textContent = saved ? `${saved} saved, then: ${err.message}` : err.message;
            }
        } finally{
            button.disabled = false;
            button.innerHTML = original;
        }
    });
    return true;
}

});

parcelRegister("iPsZ0", function(module, exports) {

$parcel$export(module.exports, "wireCopy", () => $db5378cf31720742$export$7167b346a0f58311);
// Putting a finished picture on the clipboard.
//
// The people these tools are for paste into Discord more often than they
// attach a file, so a copy button sits next to every "Save image" on the tools
// that produce one picture. It is a convenience on top of saving, never a
// replacement, and on a browser that cannot write images to the clipboard it
// is simply not shown.
/** Whether this browser can put an image on the clipboard at all. */ function $db5378cf31720742$export$9cdf378d4048dd07() {
    return Boolean(window.isSecureContext && navigator.clipboard && typeof navigator.clipboard.write === 'function' && typeof window.ClipboardItem === 'function');
}
/**
 * The picture as PNG, the one image type every clipboard takes. A JPEG or WebP
 * result is drawn once more and re-encoded; nothing about it changes but the
 * container, and the saved file keeps the format that was picked.
 */ async function $db5378cf31720742$var$asPng(blob) {
    if (blob.type === 'image/png') return blob;
    const bitmap = await createImageBitmap(blob);
    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    canvas.getContext('2d').drawImage(bitmap, 0, 0);
    bitmap.close();
    return new Promise((resolve, reject)=>{
        canvas.toBlob((png)=>png ? resolve(png) : reject(new Error('Could not prepare the image')), 'image/png');
    });
}
function $db5378cf31720742$var$tell(message, kind) {
    if (window.ui && typeof window.ui.toast === 'function') window.ui.toast(message, kind);
}
function $db5378cf31720742$export$7167b346a0f58311({ button: button, mirror: mirror, collect: collect }) {
    if (!button || !$db5378cf31720742$export$9cdf378d4048dd07()) return;
    button.hidden = false;
    if (mirror) {
        const follow = ()=>{
            button.disabled = mirror.disabled;
        };
        follow();
        new MutationObserver(follow).observe(mirror, {
            attributes: true,
            attributeFilter: [
                'disabled'
            ]
        });
    }
    const label = button.querySelector('[data-copy-label]');
    const idle = label ? label.textContent : '';
    button.addEventListener('click', async ()=>{
        try {
            // The item is handed a promise rather than a finished blob: the
            // write has to start inside the click, and rendering a large
            // result can take longer than a browser keeps that window open.
            const png = Promise.resolve(collect()).then((result)=>{
                if (!result || !result.blob) throw new Error('Nothing to copy yet');
                return $db5378cf31720742$var$asPng(result.blob);
            });
            await navigator.clipboard.write([
                new window.ClipboardItem({
                    'image/png': png
                })
            ]);
            if (label) {
                label.textContent = 'Copied';
                setTimeout(()=>{
                    label.textContent = idle;
                }, 1600);
            }
            $db5378cf31720742$var$tell('Image copied. Paste it wherever you need it.', 'success');
        } catch (err) {
            $db5378cf31720742$var$tell('The image could not be copied here. Use Save image instead.', 'error');
        }
    });
}

});

parcelRegister("5Yt4b", function(module, exports) {

$parcel$export(module.exports, "wireOffline", () => $45991a5cfac9118c$export$7f412dbbe40928e4);
// "Make this tool work offline": the runtime and a model, stored on request.
//
// Without this, a model tool works offline only on a page where it has already
// run, because the runtime lives in that page's memory. With it, the four
// files a model tool needs are kept in Cache Storage and a small service worker
// (src/assets/sw/tools-sw.js) answers for them, so a page opened later works
// with no connection at all. It is a visible, opt-in download with its size on
// the button, not something that happens behind the visitor's back.

var $7JAKl = parcelRequire("7JAKl");
const $45991a5cfac9118c$var$CACHE = 'imageserver-tools-models-v1'; // shared with tools/onnx.js and the worker
const $45991a5cfac9118c$var$WORKER_URL = '/tools/sw.js';
// What the runtime is made of. Sizes are what the button quotes before the
// download starts; the download itself counts real bytes.
const $45991a5cfac9118c$var$RUNTIME_FILES = [
    {
        url: '/plugins/onnxruntime/ort.wasm.min.js',
        type: 'text/javascript',
        bytes: 46627
    },
    {
        url: '/plugins/onnxruntime/ort-wasm-simd-threaded.mjs',
        type: 'text/javascript',
        bytes: 26583
    },
    {
        url: '/plugins/onnxruntime/ort-wasm-simd-threaded.wasm',
        type: 'application/wasm',
        bytes: 12666427
    }
];
function $45991a5cfac9118c$export$1a813761451f9760() {
    return Boolean(window.isSecureContext && 'serviceWorker' in navigator && 'caches' in window);
}
function $45991a5cfac9118c$var$filesFor(model) {
    return [
        ...$45991a5cfac9118c$var$RUNTIME_FILES,
        {
            url: model.file,
            type: 'application/octet-stream',
            bytes: model.bytes
        }
    ];
}
async function $45991a5cfac9118c$export$1f1224dc11714ba1(model) {
    if (!$45991a5cfac9118c$export$1a813761451f9760()) return false;
    try {
        const cache = await caches.open($45991a5cfac9118c$var$CACHE);
        const hits = await Promise.all($45991a5cfac9118c$var$filesFor(model).map((file)=>cache.match(file.url)));
        const registered = await navigator.serviceWorker.getRegistration('/tools/');
        return hits.every(Boolean) && Boolean(registered);
    } catch (err) {
        return false;
    }
}
/** Download and store what is missing, reporting 0 to 1 across all of it. */ async function $45991a5cfac9118c$var$prepare(model, onProgress) {
    await navigator.serviceWorker.register($45991a5cfac9118c$var$WORKER_URL, {
        scope: '/tools/'
    });
    const cache = await caches.open($45991a5cfac9118c$var$CACHE);
    const files = $45991a5cfac9118c$var$filesFor(model);
    const missing = [];
    for (const file of files)if (!await cache.match(file.url)) missing.push(file);
    const total = missing.reduce((sum, file)=>sum + file.bytes, 0) || 1;
    let done = 0;
    for (const file of missing){
        const response = await fetch(file.url, {
            cache: 'no-store'
        });
        if (!response.ok || !response.body) throw new Error(`Could not download ${file.url}`);
        const reader = response.body.getReader();
        const chunks = [];
        for(;;){
            const { done: finished, value: value } = await reader.read();
            if (finished) break;
            chunks.push(value);
            done += value.length;
            if (onProgress) onProgress(Math.min(1, done / total));
        }
        // Stored with its type: the runtime compiles the WebAssembly as a
        // stream and imports the glue module, and both refuse a response
        // without the right one.
        await cache.put(file.url, new Response(new Blob(chunks, {
            type: file.type
        }), {
            headers: {
                'Content-Type': file.type
            }
        }));
    }
    await navigator.serviceWorker.ready;
}
function $45991a5cfac9118c$export$7f412dbbe40928e4({ root: root, button: button, note: note, model: model }) {
    if (!root || !$45991a5cfac9118c$export$1a813761451f9760()) return ()=>{};
    root.hidden = false;
    const label = button.querySelector('[data-offline-label]');
    let busy = false;
    const sizeOf = (m)=>$45991a5cfac9118c$var$filesFor(m).reduce((sum, file)=>sum + file.bytes, 0);
    const refresh = async ()=>{
        if (busy) return;
        const current = model();
        if (await $45991a5cfac9118c$export$1f1224dc11714ba1(current)) {
            button.hidden = true;
            note.textContent = `Ready offline. This tool now works in this browser without a connection.`;
        } else {
            button.hidden = false;
            button.disabled = false;
            label.textContent = `Make this tool work offline (${(0, $7JAKl.formatBytes)(sizeOf(current))})`;
            const which = current.label ? `the ${current.label} model` : 'the model';
            note.textContent = `Stores the runtime and ${which} in this browser, so a page opened later works without a connection.`;
        }
    };
    button.addEventListener('click', async ()=>{
        if (busy) return;
        busy = true;
        button.disabled = true;
        const current = model();
        try {
            await $45991a5cfac9118c$var$prepare(current, (fraction)=>{
                label.textContent = `Downloading, ${Math.round(fraction * 100)}%`;
            });
            busy = false;
            await refresh();
        } catch (err) {
            busy = false;
            button.disabled = false;
            label.textContent = 'Try again';
            note.textContent = navigator.onLine === false ? 'You are offline. Connect, then try again.' : 'The download did not finish. Try again.';
        }
    });
    refresh();
    return refresh;
}

});

// The background remover on /tools/background-remover.
//
// The model does the expensive part once per image. Changing the backdrop or
// the output format afterwards only redraws the cut-out that is already in
// memory, so those controls answer instantly rather than costing another run.
// Background removal, start to finish, inside the browser.
//
// A U-2-Net model looks at a 320x320 copy of the picture and answers with a
// saliency map: one number per pixel saying how much that pixel belongs to the
// subject. That map, scaled back up, becomes the alpha channel of the original.
//
// Loading the model and the runtime is tools/onnx.js, shared with the upscaler.
// Nothing is sent anywhere: the only requests either module makes are for two
// static files on this origin, and after the first visit the Cache Storage
// answers even those.

var $8hRDK = parcelRequire("8hRDK");
// What the network was trained on. Both models take the same input, so the
// numbers below are not per-model.
const $d9d3a3b2e6139f1b$var$INPUT_SIZE = 320;
const $d9d3a3b2e6139f1b$var$MEAN = [
    0.485,
    0.456,
    0.406
];
const $d9d3a3b2e6139f1b$var$STD = [
    0.229,
    0.224,
    0.225
];
// Above this on the long edge the result is scaled down before the mask is
// applied. A 48 megapixel photo needs three buffers of four bytes per pixel at
// once, which is where a phone browser stops rather than slows down.
const $d9d3a3b2e6139f1b$var$MAX_OUTPUT_EDGE = 4096;
const $d9d3a3b2e6139f1b$export$fb9ba57710875005 = [
    {
        id: 'fast',
        file: '/models/u2netp.onnx',
        label: 'Fast',
        bytes: 4574861,
        note: 'Small download, good on clear subjects'
    },
    {
        id: 'accurate',
        file: '/models/silueta.onnx',
        label: 'Accurate',
        bytes: 44173029,
        note: 'Larger download, better on hair and thin edges'
    }
];
/** The picture as the tensor the network expects: 1x3x320x320, normalised. */ function $d9d3a3b2e6139f1b$var$toTensor(ort, image) {
    const canvas = document.createElement('canvas');
    canvas.width = $d9d3a3b2e6139f1b$var$INPUT_SIZE;
    canvas.height = $d9d3a3b2e6139f1b$var$INPUT_SIZE;
    const ctx = canvas.getContext('2d', {
        willReadFrequently: true
    });
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    // Squashed to a square rather than letterboxed. That is how the model was
    // trained and how every reference implementation feeds it, and the mask is
    // stretched back the same way afterwards.
    ctx.drawImage(image, 0, 0, $d9d3a3b2e6139f1b$var$INPUT_SIZE, $d9d3a3b2e6139f1b$var$INPUT_SIZE);
    const { data: data } = ctx.getImageData(0, 0, $d9d3a3b2e6139f1b$var$INPUT_SIZE, $d9d3a3b2e6139f1b$var$INPUT_SIZE);
    const pixels = $d9d3a3b2e6139f1b$var$INPUT_SIZE * $d9d3a3b2e6139f1b$var$INPUT_SIZE;
    // Scaled by the brightest channel present rather than by 255, which is what
    // the reference implementations do. On an evenly exposed picture the two
    // are the same; on a dark one this lifts it into the range the network saw
    // during training.
    let peak = 0;
    for(let i = 0; i < data.length; i += 4){
        if (data[i] > peak) peak = data[i];
        if (data[i + 1] > peak) peak = data[i + 1];
        if (data[i + 2] > peak) peak = data[i + 2];
    }
    if (peak === 0) peak = 1;
    // Channel first: all the reds, then all the greens, then all the blues.
    const input = new Float32Array(3 * pixels);
    for(let p = 0; p < pixels; p += 1){
        const source = p * 4;
        for(let c = 0; c < 3; c += 1)input[c * pixels + p] = (data[source + c] / peak - $d9d3a3b2e6139f1b$var$MEAN[c]) / $d9d3a3b2e6139f1b$var$STD[c];
    }
    return new ort.Tensor('float32', input, [
        1,
        3,
        $d9d3a3b2e6139f1b$var$INPUT_SIZE,
        $d9d3a3b2e6139f1b$var$INPUT_SIZE
    ]);
}
/**
 * The network's first output as a 320x320 grayscale mask.
 *
 * The raw numbers are not bounded to a usable range, so they are stretched
 * between their own smallest and largest value. Without that the mask on a
 * low-contrast picture comes out uniformly grey and everything turns
 * half-transparent.
 */ function $d9d3a3b2e6139f1b$var$toMask(output) {
    const values = output.data;
    let min = Infinity;
    let max = -Infinity;
    for(let i = 0; i < values.length; i += 1){
        if (values[i] < min) min = values[i];
        if (values[i] > max) max = values[i];
    }
    const span = max - min || 1;
    const mask = new Uint8ClampedArray($d9d3a3b2e6139f1b$var$INPUT_SIZE * $d9d3a3b2e6139f1b$var$INPUT_SIZE * 4);
    for(let p = 0; p < $d9d3a3b2e6139f1b$var$INPUT_SIZE * $d9d3a3b2e6139f1b$var$INPUT_SIZE; p += 1){
        const value = (values[p] - min) / span * 255;
        // Written into all three colour channels, opaque. The mask is scaled up
        // by drawing it, and a browser interpolates colour smoothly while it
        // would not blend into a transparent neighbour the same way.
        const target = p * 4;
        mask[target] = value;
        mask[target + 1] = value;
        mask[target + 2] = value;
        mask[target + 3] = 255;
    }
    return new ImageData(mask, $d9d3a3b2e6139f1b$var$INPUT_SIZE, $d9d3a3b2e6139f1b$var$INPUT_SIZE);
}
/** The mask, scaled to the output size, as one byte of coverage per pixel. */ function $d9d3a3b2e6139f1b$var$scaleMask(maskData, width, height) {
    const small = document.createElement('canvas');
    small.width = $d9d3a3b2e6139f1b$var$INPUT_SIZE;
    small.height = $d9d3a3b2e6139f1b$var$INPUT_SIZE;
    small.getContext('2d').putImageData(maskData, 0, 0);
    const large = document.createElement('canvas');
    large.width = width;
    large.height = height;
    const ctx = large.getContext('2d', {
        willReadFrequently: true
    });
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(small, 0, 0, width, height);
    return ctx.getImageData(0, 0, width, height).data;
}
async function $d9d3a3b2e6139f1b$export$bcbafd0c688e5b8d(image, { model: model, onDownload: onDownload, onStage: onStage } = {}) {
    const chosen = model || $d9d3a3b2e6139f1b$export$fb9ba57710875005[0];
    if (onStage) onStage('Preparing the model');
    const session = await (0, $8hRDK.sessionFor)(chosen, onDownload);
    const ort = await (0, $8hRDK.loadRuntime)();
    if (onStage) onStage('Looking at the image');
    const feeds = {
        [session.inputNames[0]]: $d9d3a3b2e6139f1b$var$toTensor(ort, image)
    };
    const results = await session.run(feeds);
    const maskData = $d9d3a3b2e6139f1b$var$toMask(results[session.outputNames[0]]);
    if (onStage) onStage('Cutting out the subject');
    const sourceWidth = image.width || image.naturalWidth;
    const sourceHeight = image.height || image.naturalHeight;
    const scale = Math.min(1, $d9d3a3b2e6139f1b$var$MAX_OUTPUT_EDGE / Math.max(sourceWidth, sourceHeight));
    const width = Math.max(1, Math.round(sourceWidth * scale));
    const height = Math.max(1, Math.round(sourceHeight * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d', {
        willReadFrequently: true
    });
    ctx.drawImage(image, 0, 0, width, height);
    const picture = ctx.getImageData(0, 0, width, height);
    const coverage = $d9d3a3b2e6139f1b$var$scaleMask(maskData, width, height);
    for(let i = 0; i < picture.data.length; i += 4)// Multiplied into whatever alpha the picture already had, so a PNG that
    // arrived with transparent corners keeps them.
    picture.data[i + 3] = picture.data[i + 3] * coverage[i] / 255;
    ctx.putImageData(picture, 0, 0);
    return canvas;
}



var $8hRDK = parcelRequire("8hRDK");

var $7JAKl = parcelRequire("7JAKl");

var $65gAn = parcelRequire("65gAn");

var $iPsZ0 = parcelRequire("iPsZ0");

var $5Yt4b = parcelRequire("5Yt4b");

var $1Euqv = parcelRequire("1Euqv");
// PNG first: it is the only one of the three that keeps a transparent backdrop,
// which is the point of the tool.
const $da3721429e569a7c$var$FORMATS = [
    {
        mime: 'image/png',
        label: 'PNG',
        extension: 'png',
        transparent: true,
        quality: undefined
    },
    {
        mime: 'image/webp',
        label: 'WebP',
        extension: 'webp',
        transparent: true,
        quality: 0.92
    },
    {
        mime: 'image/jpeg',
        label: 'JPEG',
        extension: 'jpg',
        transparent: false,
        quality: 0.92
    }
];
const $da3721429e569a7c$var$el = (id)=>document.getElementById(id);
const $da3721429e569a7c$var$dom = {
    zone: $da3721429e569a7c$var$el('bgZone'),
    input: $da3721429e569a7c$var$el('bgInput'),
    empty: $da3721429e569a7c$var$el('bgEmpty'),
    workspace: $da3721429e569a7c$var$el('bgWorkspace'),
    model: $da3721429e569a7c$var$el('bgModel'),
    modelNote: $da3721429e569a7c$var$el('bgModelNote'),
    backdrop: $da3721429e569a7c$var$el('bgBackdrop'),
    colourRow: $da3721429e569a7c$var$el('bgColourRow'),
    colour: $da3721429e569a7c$var$el('bgColour'),
    format: $da3721429e569a7c$var$el('bgFormat'),
    status: $da3721429e569a7c$var$el('bgStatus'),
    statusText: $da3721429e569a7c$var$el('bgStatusText'),
    progress: $da3721429e569a7c$var$el('bgProgress'),
    progressBar: $da3721429e569a7c$var$el('bgProgressBar'),
    error: $da3721429e569a7c$var$el('bgError'),
    errorText: $da3721429e569a7c$var$el('bgErrorText'),
    retry: $da3721429e569a7c$var$el('bgRetry'),
    live: $da3721429e569a7c$var$el('bgLive'),
    preview: $da3721429e569a7c$var$el('bgPreview'),
    image: $da3721429e569a7c$var$el('bgImage'),
    compare: $da3721429e569a7c$var$el('bgCompare'),
    meta: $da3721429e569a7c$var$el('bgMeta'),
    download: $da3721429e569a7c$var$el('bgDownload'),
    reset: $da3721429e569a7c$var$el('bgReset'),
    saveAccount: $da3721429e569a7c$var$el('toolSaveAccount'),
    savePanel: $da3721429e569a7c$var$el('toolSavePanel'),
    saveList: $da3721429e569a7c$var$el('toolSaveList'),
    saveError: $da3721429e569a7c$var$el('toolSaveError')
};
const $da3721429e569a7c$var$state = {
    file: null,
    source: null,
    sourceUrl: null,
    cutout: null,
    output: null,
    running: false
};
function $da3721429e569a7c$var$format() {
    return $da3721429e569a7c$var$FORMATS.find((f)=>f.mime === $da3721429e569a7c$var$dom.format.value) || $da3721429e569a7c$var$FORMATS[0];
}
function $da3721429e569a7c$var$backdrop() {
    // JPEG has no alpha channel to be transparent in. Rather than letting the
    // encoder decide what shows through, which is black in some browsers and
    // white in others, the colour is made explicit and the control says so.
    if (!$da3721429e569a7c$var$format().transparent) return $da3721429e569a7c$var$dom.colour.value;
    return $da3721429e569a7c$var$dom.backdrop.value === 'colour' ? $da3721429e569a7c$var$dom.colour.value : null;
}
function $da3721429e569a7c$var$syncControls() {
    const transparentPossible = $da3721429e569a7c$var$format().transparent;
    $da3721429e569a7c$var$dom.backdrop.disabled = !transparentPossible;
    $da3721429e569a7c$var$dom.colourRow.hidden = transparentPossible && $da3721429e569a7c$var$dom.backdrop.value !== 'colour';
    const model = (0, $d9d3a3b2e6139f1b$export$fb9ba57710875005).find((m)=>m.id === $da3721429e569a7c$var$dom.model.value) || (0, $d9d3a3b2e6139f1b$export$fb9ba57710875005)[0];
    $da3721429e569a7c$var$dom.modelNote.textContent = `${model.note}. ${(0, $7JAKl.formatBytes)(model.bytes)} model, plus the ${(0, $7JAKl.formatBytes)((0, $8hRDK.RUNTIME_BYTES))} runtime the first time.`;
}
function $da3721429e569a7c$var$setStatus(text, fraction) {
    // The live region hears each new stage once; the bar's percentages are
    // left to the progressbar role, which a screen reader can ask for.
    if (text && text !== $da3721429e569a7c$var$dom.statusText.textContent) $da3721429e569a7c$var$dom.live.textContent = text;
    $da3721429e569a7c$var$dom.status.hidden = !text;
    $da3721429e569a7c$var$dom.statusText.textContent = text || '';
    $da3721429e569a7c$var$dom.progress.hidden = fraction === undefined;
    if (fraction !== undefined) {
        const percent = Math.round(fraction * 100);
        $da3721429e569a7c$var$dom.progressBar.style.width = `${percent}%`;
        $da3721429e569a7c$var$dom.progress.setAttribute('aria-valuenow', String(percent));
    }
}
/**
 * Show a problem, or clear it with an empty message.
 *
 * @param {string} message
 * @param {object} [options]
 * @param {boolean} [options.retry]   Offer "Try again", for a download that failed.
 * @param {boolean} [options.notice]  A refusal rather than a failure, shown in amber.
 */ function $da3721429e569a7c$var$setError(message, { retry: retry = false, notice: notice = false } = {}) {
    $da3721429e569a7c$var$dom.error.hidden = !message;
    $da3721429e569a7c$var$dom.errorText.textContent = message || '';
    $da3721429e569a7c$var$dom.retry.hidden = !(message && retry);
    $da3721429e569a7c$var$dom.error.classList.toggle('bg-red-50', !notice);
    $da3721429e569a7c$var$dom.error.classList.toggle('dark:bg-red-950/30', !notice);
    $da3721429e569a7c$var$dom.error.classList.toggle('border-red-200/50', !notice);
    $da3721429e569a7c$var$dom.error.classList.toggle('dark:border-red-800/50', !notice);
    $da3721429e569a7c$var$dom.error.classList.toggle('text-red-700', !notice);
    $da3721429e569a7c$var$dom.error.classList.toggle('dark:text-red-300', !notice);
    $da3721429e569a7c$var$dom.error.classList.toggle('bg-amber-50', notice);
    $da3721429e569a7c$var$dom.error.classList.toggle('dark:bg-amber-950/30', notice);
    $da3721429e569a7c$var$dom.error.classList.toggle('border-amber-200/50', notice);
    $da3721429e569a7c$var$dom.error.classList.toggle('dark:border-amber-800/50', notice);
    $da3721429e569a7c$var$dom.error.classList.toggle('text-amber-800', notice);
    $da3721429e569a7c$var$dom.error.classList.toggle('dark:text-amber-200', notice);
}
function $da3721429e569a7c$var$releaseOutput() {
    if ($da3721429e569a7c$var$state.output) URL.revokeObjectURL($da3721429e569a7c$var$state.output.url);
    $da3721429e569a7c$var$state.output = null;
}
/** Redraw the cut-out over the chosen backdrop and encode it. */ async function $da3721429e569a7c$var$present() {
    if (!$da3721429e569a7c$var$state.cutout) return;
    const chosen = $da3721429e569a7c$var$format();
    const colour = $da3721429e569a7c$var$backdrop();
    const canvas = document.createElement('canvas');
    canvas.width = $da3721429e569a7c$var$state.cutout.width;
    canvas.height = $da3721429e569a7c$var$state.cutout.height;
    const ctx = canvas.getContext('2d');
    if (colour) {
        ctx.fillStyle = colour;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    ctx.drawImage($da3721429e569a7c$var$state.cutout, 0, 0);
    const blob = await (0, $7JAKl.encode)(canvas, chosen.mime, chosen.quality);
    $da3721429e569a7c$var$releaseOutput();
    $da3721429e569a7c$var$state.output = {
        blob: blob,
        name: (0, $7JAKl.renameExtension)($da3721429e569a7c$var$state.file.name, chosen.extension),
        url: URL.createObjectURL(blob)
    };
    // The checkerboard behind the preview only makes sense while something is
    // actually see-through.
    $da3721429e569a7c$var$dom.preview.classList.toggle('is-transparent', !colour);
    if (!$da3721429e569a7c$var$dom.compare.getAttribute('aria-pressed') || $da3721429e569a7c$var$dom.compare.getAttribute('aria-pressed') === 'false') $da3721429e569a7c$var$dom.image.src = $da3721429e569a7c$var$state.output.url;
    $da3721429e569a7c$var$dom.download.disabled = false;
    $da3721429e569a7c$var$dom.meta.textContent = `${canvas.width} x ${canvas.height} - ${(0, $7JAKl.formatBytes)(blob.size)} - ${$da3721429e569a7c$var$state.output.name}`;
}
async function $da3721429e569a7c$var$process() {
    if (!$da3721429e569a7c$var$state.source || $da3721429e569a7c$var$state.running) return;
    $da3721429e569a7c$var$state.running = true;
    $da3721429e569a7c$var$dom.download.disabled = true;
    $da3721429e569a7c$var$setError('');
    try {
        const model = (0, $d9d3a3b2e6139f1b$export$fb9ba57710875005).find((m)=>m.id === $da3721429e569a7c$var$dom.model.value) || (0, $d9d3a3b2e6139f1b$export$fb9ba57710875005)[0];
        $da3721429e569a7c$var$state.cutout = await (0, $d9d3a3b2e6139f1b$export$bcbafd0c688e5b8d)($da3721429e569a7c$var$state.source, {
            model: model,
            onDownload: (fraction)=>$da3721429e569a7c$var$setStatus(`Downloading the ${model.label.toLowerCase()} model`, fraction),
            onStage: (text)=>$da3721429e569a7c$var$setStatus(text)
        });
        $da3721429e569a7c$var$setStatus('Rendering');
        await $da3721429e569a7c$var$present();
        $da3721429e569a7c$var$setStatus('');
    } catch (err) {
        $da3721429e569a7c$var$setStatus('');
        $da3721429e569a7c$var$setError((0, $8hRDK.explainLoadError)(err), {
            retry: true
        });
    } finally{
        $da3721429e569a7c$var$state.running = false;
    }
}
function $da3721429e569a7c$var$reset() {
    $da3721429e569a7c$var$releaseOutput();
    if ($da3721429e569a7c$var$state.sourceUrl) URL.revokeObjectURL($da3721429e569a7c$var$state.sourceUrl);
    if ($da3721429e569a7c$var$state.source?.close) $da3721429e569a7c$var$state.source.close();
    $da3721429e569a7c$var$state.file = null;
    $da3721429e569a7c$var$state.source = null;
    $da3721429e569a7c$var$state.sourceUrl = null;
    $da3721429e569a7c$var$state.cutout = null;
    $da3721429e569a7c$var$dom.image.removeAttribute('src');
    $da3721429e569a7c$var$dom.workspace.hidden = true;
    $da3721429e569a7c$var$dom.empty.hidden = false;
    $da3721429e569a7c$var$dom.compare.setAttribute('aria-pressed', 'false');
    $da3721429e569a7c$var$dom.download.disabled = true;
    $da3721429e569a7c$var$dom.meta.textContent = '';
    $da3721429e569a7c$var$setStatus('');
    $da3721429e569a7c$var$setError('');
}
async function $da3721429e569a7c$var$open([file]) {
    if (!file) return;
    $da3721429e569a7c$var$reset();
    $da3721429e569a7c$var$state.file = file;
    try {
        $da3721429e569a7c$var$state.source = await (0, $7JAKl.decode)(file);
    } catch (err) {
        $da3721429e569a7c$var$setError(err.message || 'Could not read this image');
        return;
    }
    // Shown before the model has said anything, so the picture appears at once
    // and the wait happens with something on screen.
    $da3721429e569a7c$var$state.sourceUrl = URL.createObjectURL(file);
    $da3721429e569a7c$var$dom.image.src = $da3721429e569a7c$var$state.sourceUrl;
    $da3721429e569a7c$var$dom.preview.classList.remove('is-transparent');
    const { width: width, height: height } = (0, $7JAKl.sizeOf)($da3721429e569a7c$var$state.source);
    $da3721429e569a7c$var$dom.meta.textContent = `${width} x ${height} - ${(0, $7JAKl.formatBytes)(file.size)}`;
    $da3721429e569a7c$var$dom.empty.hidden = true;
    $da3721429e569a7c$var$dom.workspace.hidden = false;
    $da3721429e569a7c$var$process();
}
function $da3721429e569a7c$var$toggleCompare() {
    const showingOriginal = $da3721429e569a7c$var$dom.compare.getAttribute('aria-pressed') === 'true';
    const next = !showingOriginal;
    $da3721429e569a7c$var$dom.compare.setAttribute('aria-pressed', String(next));
    if (next) {
        $da3721429e569a7c$var$dom.image.src = $da3721429e569a7c$var$state.sourceUrl;
        $da3721429e569a7c$var$dom.preview.classList.remove('is-transparent');
    } else if ($da3721429e569a7c$var$state.output) {
        $da3721429e569a7c$var$dom.image.src = $da3721429e569a7c$var$state.output.url;
        $da3721429e569a7c$var$dom.preview.classList.toggle('is-transparent', !$da3721429e569a7c$var$backdrop());
    }
}
async function $da3721429e569a7c$var$dropUnsupportedFormats() {
    for (const option of Array.from($da3721429e569a7c$var$dom.format.options))if (!await (0, $7JAKl.canEncode)(option.value)) option.remove();
}
function $da3721429e569a7c$var$init() {
    if (!$da3721429e569a7c$var$dom.zone) return;
    (0, $65gAn.blockStrayDrops)();
    (0, $65gAn.initColourPicker)();
    (0, $65gAn.wirePicker)({
        zone: $da3721429e569a7c$var$dom.zone,
        input: $da3721429e569a7c$var$dom.input,
        multiple: false,
        onFiles: $da3721429e569a7c$var$open
    });
    $da3721429e569a7c$var$dropUnsupportedFormats().then($da3721429e569a7c$var$syncControls);
    $da3721429e569a7c$var$dom.model.addEventListener('change', ()=>{
        $da3721429e569a7c$var$syncControls();
        // A different model is a different cut-out, so this one has to run again.
        $da3721429e569a7c$var$process();
    });
    for (const control of [
        $da3721429e569a7c$var$dom.backdrop,
        $da3721429e569a7c$var$dom.format,
        $da3721429e569a7c$var$dom.colour
    ])control.addEventListener('input', ()=>{
        $da3721429e569a7c$var$syncControls();
        $da3721429e569a7c$var$present().catch((err)=>$da3721429e569a7c$var$setError(err.message || 'Could not render the result'));
    });
    $da3721429e569a7c$var$dom.compare.addEventListener('click', $da3721429e569a7c$var$toggleCompare);
    $da3721429e569a7c$var$dom.retry.addEventListener('click', ()=>{
        $da3721429e569a7c$var$setError('');
        $da3721429e569a7c$var$process();
    });
    $da3721429e569a7c$var$dom.download.addEventListener('click', ()=>{
        if ($da3721429e569a7c$var$state.output) (0, $7JAKl.saveBlob)($da3721429e569a7c$var$state.output.blob, $da3721429e569a7c$var$state.output.name);
    });
    $da3721429e569a7c$var$dom.reset.addEventListener('click', $da3721429e569a7c$var$reset);
    const recheckOffline = (0, $5Yt4b.wireOffline)({
        root: document.getElementById('bgOffline'),
        button: document.getElementById('bgOfflineButton'),
        note: document.getElementById('bgOfflineNote'),
        model: ()=>(0, $d9d3a3b2e6139f1b$export$fb9ba57710875005).find((m)=>m.id === $da3721429e569a7c$var$dom.model.value) || (0, $d9d3a3b2e6139f1b$export$fb9ba57710875005)[0]
    });
    $da3721429e569a7c$var$dom.model.addEventListener('change', recheckOffline);
    (0, $iPsZ0.wireCopy)({
        button: document.getElementById('bgCopy'),
        mirror: $da3721429e569a7c$var$dom.download,
        collect: ()=>$da3721429e569a7c$var$state.output
    });
    (0, $1Euqv.wireAccountSave)({
        button: $da3721429e569a7c$var$dom.saveAccount,
        panel: $da3721429e569a7c$var$dom.savePanel,
        list: $da3721429e569a7c$var$dom.saveList,
        error: $da3721429e569a7c$var$dom.saveError,
        // Whatever is on screen right now, which present() has already encoded
        // in the chosen format and over the chosen backdrop.
        collect: ()=>$da3721429e569a7c$var$state.output ? [
                {
                    blob: $da3721429e569a7c$var$state.output.blob,
                    name: $da3721429e569a7c$var$state.output.name
                }
            ] : []
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $da3721429e569a7c$var$init);
else $da3721429e569a7c$var$init();

})();
//# sourceMappingURL=tools-background.f66456fc.js.map
